export default function OP_Animals() {
  return(
    <p>Operationspage: Animals</p>
  )
}